class RegulatoryLevelService {
  get_data(page, data) {
    return axios.post('general/regulatory-violation-level?page=' + page, data)
  }
  get(id) {
    return axios.get('general/regulatory-violation-level/' + id)
  }
  add(data) {
    return axios.post('general/regulatory-violation-level/store', data)
  }
  edit(id, data) {
    return axios.post('general/regulatory-violation-level/update/' + id, data)
  }
  delete(id) {
    return axios.delete('general/regulatory-violation-level/delete/' + id)
  }

}
export default new RegulatoryLevelService();